/* eslint-disable no-console */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LocaleKey } from 'utils';

import { ru } from './ru';
import { en } from './en';
import { it } from './it';
import { hy } from './hy';
import { pt } from './pt';
import { es } from './es';
import { de } from './de';
import { fr } from './fr';
import { br } from './br';

const resources = {
  en,
  it,
  hy,
  ru,
  pt,
  es,
  de,
  fr,
  br,
};

const supportedLanguages = ['am', 'it', 'es', 'pt', 'fr', 'de', 'br'];
const preferedLanguageCode = navigator.language.split('-')[0];
const language = supportedLanguages.includes(preferedLanguageCode) ? preferedLanguageCode : 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('lng') || language || LocaleKey.en,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
